// extracted by mini-css-extract-plugin
module.exports = {"comment":"_11032","hd":"_14657","title":"_629","more":"_12424","text":"_2026","arrow":"_5397","tags":"_17635","item":"_2531"};